import React from 'react'
import Install from './install/Install'
import './Main.less'

export default function Main() {
	document.title = 'Sendpoll'

	return (
		<Install />
	)
}



// WEBPACK FOOTER //
// ./src/components/main/Main.jsx